export default class Plano {
	constructor() {
		this.id =  null;
		this.nome =  '';
		this.quantidadePessoas = null;
		this.quantidadeUsuarios = null;
		this.quantidadeCNPJs = null;
		this.quantidadeUsuariosApp = null;
		this.quantidadeUsuariosWeb = null;
		this.tipoPagamento = 1;		
		this.valorAnual = null;
		this.valorMensal = null;
		this.permissoesExcluidas = [];
		this.beneficios = [];
		this.validade = 'Producao';
		this.complemento = '';
	}    
}